export const unique = <T>(array: T[]): T[] => {
  const result: T[] = []
  for (const e of array) {
    if (result.includes(e)) continue
    result.push(e)
  }
  return result
}

export const chunkArray = <T>(arr: T[], chunkSize: number): T[][] => {
  const subArrayCount = Math.ceil(arr.length / chunkSize)
  const result = new Array<T[]>(subArrayCount)
  for (let i = 0; i < subArrayCount; i++) {
    const start = i * chunkSize
    const end = start + chunkSize
    result[i] = arr.slice(start, end)
  }
  return result
}

export const range: {
  (start: number, end: number): number[]
  (end: number): number[]
} = (first: number, second?: number) => {
  const array = []
  const start = second !== undefined ? first : 0
  const end = second !== undefined ? second : first
  for (let i = start; i < end; i++) {
    array.push(i)
  }
  return array
}

export const random = <T>(array: T[]): T => {
  const index = Math.floor(Math.random() * array.length)
  return array[index]
}

/** 順番も含めて同じ要素を持つか（要素は === で比較） */
export const isEqualArray = <T>(a: readonly T[], b: readonly T[]): boolean =>
  a.length === b.length && a.every((e, i) => e === b[i])
